import { Controller } from '@hotwired/stimulus';
import _debounce from 'lodash/debounce';

export default class extends Controller {
  static targets = ["errorMessage", "form", "text"];
  static values = {
    minWords: { type: Number, default: 10 },
    maxWords: { type: Number, default: 500 },
  };

  initialize() {
    this.countWords = _debounce(this.countWords, 300).bind(this);
  }

  submit(event) {
    if (this.countWords() < this.minWordsValue) {
      event.preventDefault();
      return;
    }

    this.element.requestSubmit();
  }

  countWords() {
    const words = this.textTarget.value.trim().split(/\s+/).length;
    const warning = words < this.minWordsValue && `Minimum word requirement not met. (${this.minWordsValue} words)`;

    this.errorMessageTarget.innerText = warning || `${words}/${this.maxWordsValue}`;
    this.errorMessageTarget.classList.toggle('text-danger', words >= this.maxWordsValue || words < this.minWordsValue);

    return words;
  }
}
